import React, { useState, createContext, useContext } from "react";

import { StatusType } from "components/v2/StatusBar/StatusBar";

export const StatusBarContext = createContext<any>([
  {},
  () => {
    return;
  },
]);

export const StatusBarProvider = ({
  children,
}: JSX.ElementChildrenAttribute): JSX.Element => {
  const [statusBar, setStatusBar] = useState(StatusType.DEFAULT);

  const setStatusBarToLoading = () => {
    setStatusBar(StatusType.LOADING);
  };
  const setStatusBarToHealthy = () => {
    setStatusBar(StatusType.HEALTHY);
  };
  const setStatusBarToError = () => {
    setStatusBar(StatusType.ERROR);
  };

  return (
    <StatusBarContext.Provider
      value={{
        statusBarContext: {
          statusBar: [statusBar, setStatusBar],
          setStatusBar: {
            setStatusBarToLoading,
            setStatusBarToHealthy,
            setStatusBarToError,
          },
        },
      }}
    >
      {children}
    </StatusBarContext.Provider>
  );
};

const useStatusBar = () => useContext(StatusBarContext);
export default useStatusBar;
